import { render, staticRenderFns } from "./Threedots.vue?vue&type=template&id=1116f250&scoped=true&"
import script from "./Threedots.vue?vue&type=script&lang=js&"
export * from "./Threedots.vue?vue&type=script&lang=js&"
import style0 from "./Threedots.vue?vue&type=style&index=0&id=1116f250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116f250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VIcon,VSpeedDial,VTooltip})
